import { z } from 'zod';
export const RiskLevelEnum = z.enum([
    'low',
    'medium',
    'high',
    'critical'
]);
export const RiskTypeStatusSchema = z.object({
    status: z.enum([
        'clear',
        'alert'
    ]),
    // BAL-8159: concise reasoning for every risk type — why it alerted, or (BAL-8475) why the
    // evidence fell short of the alert criteria when cleared. Nullish here (unlike the prompt
    // schemas) because this is the admin/DB-facing shape and pre-feature reports in the DB have
    // no reasoning at all — the admin edit form must still parse them.
    reasoning: z.string().nullish()
});
export const RiskTypesSchema = z.object({
    chargebacks: RiskTypeStatusSchema.nullish(),
    contentFindings: RiskTypeStatusSchema.nullish(),
    reputational: RiskTypeStatusSchema.nullish(),
    transactionLaundering: RiskTypeStatusSchema.nullish(),
    legal: RiskTypeStatusSchema.nullish(),
    // BAL-8314: Scam and Fraud risk type. nullish like the rest — populated by the underwriter prompt.
    scamAndFraud: RiskTypeStatusSchema.nullish()
});
export const RiskAssessmentSchema = z.object({
    riskLevel: RiskLevelEnum.nullish(),
    riskTypes: RiskTypesSchema.nullish(),
    isAlert: z.boolean().nullish()
}).meta({
    id: 'RiskAssessment'
});

//# sourceMappingURL=risk-assessment.schema.js.map